import reducers from '../reducers';
import { createStore, applyMiddleware, compose } from 'redux';
import { loadUser } from 'redux-oidc';
import logger from 'redux-logger';
import userManager from '../utils/userManager';
import thunk from 'redux-thunk';

function configureStore(initialState) {
  return createStore(reducers, initialState, compose(applyMiddleware(thunk, logger)));
}

const initialState = {
  oidc: { isLoadingUser: true }
};

const store = configureStore(initialState);
loadUser(store, userManager);

export default store;
